import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Spin } from 'antd';
import type { Moment } from 'moment';

import { RootState } from '../../modules';
import {
  deleteWorkRecordAsync,
  getWorkRecordListAsync,
} from '../../modules/work-records';
import WorkRecordCreateDrawer from './WorkRecordCreateDrawer';
import WorkRecordDetailDrawer from './WorkRecordDetailDrawer';
import WorkRecordEmptyDrawer from './WorkRecordEmptyDrawer';
import WorkRecordListComponent from '../../components/work-records/WorkRecordListComponent';

interface WorkRecordListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function WorkRecordListContainer({
  history,
  match,
}: RouteComponentProps<WorkRecordListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [visibleEmptyDrawer, setVisibleEmptyDrawer] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state: RootState) => state.workRecords.workRecords,
  );
  const [workRecordId, setWorkRecordId] = useState<string>();

  useEffect(() => {
    dispatch(
      getWorkRecordListAsync.request({
        enterpriseId,
        projectId,
      }),
    );
  }, [enterpriseId, projectId, dispatch]);

  const onCreate = () => {
    setVisibleCreateDrawer(true);
  };

  const onDetail = (_workRecordId: string) => {
    setWorkRecordId(_workRecordId);
    setVisibleDetailDrawer(true);
  };

  const onDelete = (_workRecordId: string) => {
    dispatch(
      deleteWorkRecordAsync.request({
        enterpriseId,
        projectId,
        workRecordId: _workRecordId,
      }),
    );
  };

  const onCloseCreateDrawer = () => {
    setVisibleCreateDrawer(false);
  };

  const onSelect = (newValue: Moment) => {
    if (data === undefined || data === null) return;
    const selectedData = data.find(
      (e) => e.createdDate === newValue.format('YYYY-MM-DD'),
    );
    if (selectedData === undefined) {
      // setVisibleEmptyDrawer(true);
      return;
    }
    setWorkRecordId(selectedData.id + '');
    setVisibleDetailDrawer(true);
  };

  return (
    <>
      {loading && <Spin />}
      {error && <Alert message={`${error}`} type="error" showIcon closable />}
      {/* {data && (
        <WorkRecordCalendarComponent
          workRecords={data}
          moveToCreatePage={onCreate}
          moveToDetailPage={onDetail}
          onDelete={onDelete}
          onSelect={onSelect}
        />
      )} */}
      {data && (
        <WorkRecordListComponent
          workRecords={data}
          moveToCreatePage={onCreate}
          moveToDetailPage={onDetail}
          onDelete={onDelete}
          onSelect={onSelect}
        />
      )}
      <WorkRecordCreateDrawer
        enterpriseId={enterpriseId}
        projectId={projectId}
        visible={visibleCreateDrawer}
        onClose={onCloseCreateDrawer}
      />
      {workRecordId && (
        <WorkRecordDetailDrawer
          enterpriseId={enterpriseId}
          projectId={projectId}
          workRecordId={workRecordId}
          visibleDetailDrawer={visibleDetailDrawer}
          onClose={() => {
            setVisibleDetailDrawer(false);
          }}
        />
      )}
      {visibleEmptyDrawer && (
        <WorkRecordEmptyDrawer
          visibleEmptyDrawer={visibleEmptyDrawer}
          openCreateDrawer={onCreate}
          onClose={() => setVisibleEmptyDrawer(false)}
        />
      )}
    </>
  );
}

export default WorkRecordListContainer;
